import React from 'react'
import 'antd/lib/date-picker/style/index.css'
import moment from 'moment'
import { DatePicker } from 'antd'

const { RangePicker } = DatePicker

const FilterUpdateAt = ({ handleChangeDate, updated, placeholder, field, valueDraft, onResetDateDraft }) => {
    let timeout = 0
    const { from: startOfMonth, to: endOfMonth } = Object.assign({}, valueDraft)

    const _handleDateChange = async (date, dateString) => {
        const [from, to] = dateString

        if (timeout) {
            clearTimeout(timeout)
        }

        if(field === "approved_at") onResetDateDraft()

        if (typeof handleChangeDate === 'function') {
            const filters = Object.assign({}, updated)

            filters[field] = {
                from,
                to
            }

            if (!to && !from) {
                delete filters[field]
            }

            await handleChangeDate(filters)
        }
    }

    return (
        <div className='FilterUpdateAt'>
            {
                field === "approved_at" ? (
                    <RangePicker
                        placeholder={placeholder}
                        value={[updated[field] !== undefined ? moment(updated[field].from, 'DD/MM/YYYY') : startOfMonth, updated[field] !== undefined ? moment(updated[field].to, 'DD/MM/YYYY') : endOfMonth]}
                        ranges={{
                            'Today': [moment(), moment()],
                            'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }}
                        format={'DD/MM/YYYY'}
                        onChange={_handleDateChange}
                        className="w-100"
                        
                    />
                ) :
                    (
                        <RangePicker
                            placeholder={placeholder}
                            value={[updated[field] !== undefined ? moment(updated[field].from, 'DD/MM/YYYY') : '', updated[field] !== undefined ? moment(updated[field].to, 'DD/MM/YYYY') : '']}
                            ranges={{
                                'Today': [moment(), moment()],
                                'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                            }}
                            format={'DD/MM/YYYY'}
                            onChange={_handleDateChange}
                            className="w-100"
                        />
                    )
            }

        </div>
    )
}

export default FilterUpdateAt